export default import.meta.ROLLDOWN_FILE_URL_59V5P0nlnSpKXSIm6l5mmA